import { Divider, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import KingBedRoundedIcon from '@material-ui/icons/KingBedRounded'
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom'
import PeopleIcon from '@material-ui/icons/People'
import React from 'react'

import { formatShortDateWithWeekDay } from '../../../../helpers/date'
import { getTranslate, lang } from '../../../../localization'
import { SelectedRoomDetails } from '../../../../types/cart'
import { useStyles } from './styles/index.styles'

type RoomListProps = { items: SelectedRoomDetails[] | undefined }
export default function SelectedRoomList({ items }: RoomListProps) {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <div className={classes.container}>
      <Typography variant="h4" className={classes.header}>
        {getTranslate('Selected Room(s)')}
      </Typography>
      {items &&
        items.map((room, index) => (
          <div key={index} className={classes.roomCard}>
            <div className={classes.roomInfo}>
              <Typography
                variant="subtitle1"
                gutterBottom
                className={classes.title}>
                <MeetingRoomIcon style={{ marginRight: 4, fontSize: 22 }} />
                {room.roomTypeName}
              </Typography>
              <Typography variant="h5" className={classes.subtitle}>
                {room.ratePlanName}
              </Typography>
              {isMobile && <Divider className={classes.divider} />}
            </div>

            <div className={classes.midCol}>
              <div className={classes.detailItem}>
                <PeopleIcon fontSize="small" className={classes.icon} />
                <Typography variant="h5" className={classes.text}>
                  {`${getTranslate('Reserved for')}: ${
                    room.occupancy.adults
                  } ${getTranslate('Adults')}`}
                </Typography>
              </div>
              <div className={classes.detailItem}>
                <KingBedRoundedIcon fontSize="small" className={classes.icon} />
                <Typography variant="h5" className={classes.text}>
                  {getTranslate(room.boardType)}
                </Typography>
              </div>
            </div>

            <div className={classes.col}>
              <div className={classes.detailItem}>
                <Typography variant="h5" className={classes.subtitle}>
                  {`${getTranslate('Check-in')}:`}&nbsp;
                </Typography>
                <Typography variant="h5" className={classes.blackText}>
                  {formatShortDateWithWeekDay(room.checkIn, lang)}
                </Typography>
              </div>
              <div className={classes.detailItem}>
                <Typography variant="h5" className={classes.subtitle}>
                  {`${getTranslate('Check-out')}:`}&nbsp;
                </Typography>
                <Typography variant="h5" className={classes.blackText}>
                  {formatShortDateWithWeekDay(room.checkOut, lang)}
                </Typography>
              </div>
            </div>
          </div>
        ))}
    </div>
  )
}
